
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexfSNz6zFuLOjXpr58s59EKb1kTblF49blfCzqpTZM_451gMeta } from "/tmp/build_5fd1643e/pages/app/me/index.vue?macro=true";
import { default as meoflm_4t0LxX_45av5VTCwblyuhVHZEkrSqWRo9FCneCuAMeta } from "/tmp/build_5fd1643e/pages/app/me.vue?macro=true";
import { default as mapGr6LghDr4R1P1KQ6opt1czsKiyCouyNTR1e1toWLL5MMeta } from "/tmp/build_5fd1643e/pages/app/map.vue?macro=true";
import { default as posttr4k1NyoxQ3RjVjn94gGleI0sTCYVzRGchcKLgSPpcoMeta } from "/tmp/build_5fd1643e/pages/app/feed/post.vue?macro=true";
import { default as indexDsMcTvdZr3K9ycjstvoZX3MPh5vqUAZey1_45l9KpbOxgMeta } from "/tmp/build_5fd1643e/pages/app/feed/index.vue?macro=true";
import { default as _91type_93LQJna88Zh9iI0ALbYGdnEdgRGTt4Bw18osokL9GUk4oMeta } from "/tmp/build_5fd1643e/pages/app/feed/[type].vue?macro=true";
import { default as feedgBl5bjZnJZGsU2hPHrB7ddiCRgVW45j_1eNO4DCbicsMeta } from "/tmp/build_5fd1643e/pages/app/feed.vue?macro=true";
import { default as indexwVSctWQ39IVNvfFY2l7Tg19V3iSl0kW521jF698E18EMeta } from "/tmp/build_5fd1643e/pages/app/index.vue?macro=true";
import { default as eulaTAoHC4jcBxVdMhqP7VmGACgteF_4YNX5CUS6el8to3cMeta } from "/tmp/build_5fd1643e/pages/main/eula.vue?macro=true";
import { default as quizIfaMX7z17QahxOUitwjUpDv3E_45jUkrdpkW4TKniYLPkMeta } from "/tmp/build_5fd1643e/pages/admin/quiz.vue?macro=true";
import { default as indexOYp_hr_45bMbxkWDA0S3vgcGvBtr3Y7FJfZ90U3b8m0mwMeta } from "/tmp/build_5fd1643e/pages/app/groups/index.vue?macro=true";
import { default as edit5TIp3kZgixdo0oLmjYAzboaqZ42yA7ErR5Xi1NCxcMYMeta } from "/tmp/build_5fd1643e/pages/app/groups/[slug]/edit.vue?macro=true";
import { default as aboutcFHx5wT6wYyfWS8tOJwYh_7zr_45U4MVFmc4rFeoDZqe8Meta } from "/tmp/build_5fd1643e/pages/app/groups/[slug]/about.vue?macro=true";
import { default as indexRiJilbBUBg2rY1_45DuZUzeBeitl4hgl1gIv797gg4l04Meta } from "/tmp/build_5fd1643e/pages/app/groups/[slug]/index.vue?macro=true";
import { default as eventsgV_45L0K6tc_455oG0qiN41En7bO_90pbuaTVOQgqccNg14Meta } from "/tmp/build_5fd1643e/pages/app/groups/[slug]/events.vue?macro=true";
import { default as membersY3RhDgD8XGuxohvAFHZdNwsUg_45H0ySxWJ4_IKDzM8PgMeta } from "/tmp/build_5fd1643e/pages/app/groups/[slug]/members.vue?macro=true";
import { default as conversationsa4ZLhOuV3LC6weXG05HlsQSxYxxsvstjC0po_hjmraMMeta } from "/tmp/build_5fd1643e/pages/app/groups/[slug]/conversations.vue?macro=true";
import { default as _91slug_93_zzTANY_45tYnryox4kiX9MvbA3OWYzZgNt_45amkW_u8_45gMeta } from "/tmp/build_5fd1643e/pages/app/groups/[slug].vue?macro=true";
import { default as createnO3Lm0K_45BTt0DecNKunBuigToAxr0yousOfXjcQe2_45sMeta } from "/tmp/build_5fd1643e/pages/app/groups/create.vue?macro=true";
import { default as groups4L_45g269ne9vnCv81OqJBv5Qxc4qqWSOdnQ87cRsgVPsMeta } from "/tmp/build_5fd1643e/pages/app/groups.vue?macro=true";
import { default as indexJL_kQ4bD1ksWN6nF72Ovt8IZbyBvVmwuMzNYuGt8iSEMeta } from "/tmp/build_5fd1643e/pages/app/params/index.vue?macro=true";
import { default as account_h9AtNMdDZ1g3Z5RbetsT_IFR8SRBraBPXPA87Jv56kMeta } from "/tmp/build_5fd1643e/pages/app/params/account.vue?macro=true";
import { default as transactionsa9HSSn4A2V_45eohgqnwWOxhFE_45MKeuVkXZI2_KKbAWkAMeta } from "/tmp/build_5fd1643e/pages/app/params/transactions.vue?macro=true";
import { default as paramsxPCQ1YgO2g8lTKupqjIfsBiFig5Rry7iCBFlL2dPBUoMeta } from "/tmp/build_5fd1643e/pages/app/params.vue?macro=true";
import { default as indexoRUFpAn5JZSWAenZngDJ_45Y601fgwpT6KWmLO9SGkPaoMeta } from "/tmp/build_5fd1643e/pages/main/index.vue?macro=true";
import { default as pressH9frTRaSwyhOBTwNUMjvg1FJMzbB2AvLcYhKZ9iTGVoMeta } from "/tmp/build_5fd1643e/pages/main/press.vue?macro=true";
import { default as codesbqnSuMlq2j_45mhGaTz3y1oT8m2wmQVA1giMog9a1BnRcMeta } from "/tmp/build_5fd1643e/pages/admin/codes.vue?macro=true";
import { default as indexZDj11aILdWswQApPGQd93olffd8BmAQW8TTukHW_45JuAMeta } from "/tmp/build_5fd1643e/pages/admin/index.vue?macro=true";
import { default as indexlwCzVppMqBJ1cr1njjPWU2yCsXxmJ4FeXIrda4dqHEkMeta } from "/tmp/build_5fd1643e/pages/app/hangout/index.vue?macro=true";
import { default as agendaT5qOENNgs4JvinoQhxlyK8JhnZ8AK4YAgaSHyPd1ZtAMeta } from "/tmp/build_5fd1643e/pages/app/hangout/agenda.vue?macro=true";
import { default as meetupsrBHpl4_45kfPSr_DnX4c_f_45FrXonO8eEVxqVq7x4T7jXAMeta } from "/tmp/build_5fd1643e/pages/app/hangout/meetups.vue?macro=true";
import { default as organizeK8fI8ofB9mE3SJcvDs0USWDZ8Lp8k3pbMWgR0X3CD_45gMeta } from "/tmp/build_5fd1643e/pages/app/hangout/organize.vue?macro=true";
import { default as hangoutzFsiKRV7NjazThcJREdyWhwSJtlwSrRYbs0lXnRws4IMeta } from "/tmp/build_5fd1643e/pages/app/hangout.vue?macro=true";
import { default as charte6Owfx4_If6rpFlD9ZQ1gVEq3XCuXxWE5tRWBNHA_aEsMeta } from "/tmp/build_5fd1643e/pages/main/charte.vue?macro=true";
import { default as franceoQj9DkNkX3GR44nwBWVvq7MAemxlGKlpmQl0MKmY_BYMeta } from "/tmp/build_5fd1643e/pages/main/france.vue?macro=true";
import { default as themesHCoAkE0ZjmbzuqKupJ09ZVNLyOPqkNIdGI_4522P0FgtsMeta } from "/tmp/build_5fd1643e/pages/admin/themes.vue?macro=true";
import { default as indexGsQsqEOSybgal_3e0ioojvh6h5CCc52zW64KXIzaTecMeta } from "/tmp/build_5fd1643e/pages/app/insiders/index.vue?macro=true";
import { default as suggestionsW5vaBJrFDCdP5P0SacIVi0TU9UsMoye5Q3YhimjMvmEMeta } from "/tmp/build_5fd1643e/pages/app/insiders/suggestions.vue?macro=true";
import { default as insidersduxQPWhGnGclT3wTdTwerMPjq0Fa9HbGVl3lzcditToMeta } from "/tmp/build_5fd1643e/pages/app/insiders.vue?macro=true";
import { default as messages1NbqKLXgNZUPrBV223dsJVRC20wIJ40s6QhpJB0pIZsMeta } from "/tmp/build_5fd1643e/pages/app/messages.vue?macro=true";
import { default as privacyZenwQmkImbyKGHm2rX3VG2XVT3wibWyDNxhVNSOe88MMeta } from "/tmp/build_5fd1643e/pages/main/privacy.vue?macro=true";
import { default as trainerFESIsgxBFL70jxYAa4iSZ0vNQI6TrFTp_Ph6UF4Zl0UMeta } from "/tmp/build_5fd1643e/pages/admin/trainer.vue?macro=true";
import { default as indexS7UGE8dbY49uWXuYacZAUD_6Iozd_45RmDNzWaFPVNpPYMeta } from "/tmp/build_5fd1643e/pages/app/community/index.vue?macro=true";
import { default as searchUnCrxsN8kqJiuQCtHALAqQZdKfqdjXNAVqYdb5EKt5IMeta } from "/tmp/build_5fd1643e/pages/app/community/search.vue?macro=true";
import { default as besties1xQLQOOlYfxd9JKhgfNeDCkzxixOYPNJ_GjKqS1EfuoMeta } from "/tmp/build_5fd1643e/pages/app/community/besties.vue?macro=true";
import { default as indexpXe9QK4kzHWeaonFGAiaARJZLa8UF_BDMT8DqBtDyHEMeta } from "/tmp/build_5fd1643e/pages/app/community/[type]/index.vue?macro=true";
import { default as communityXNPjwMS_5RD1B9KCoYi3Rl869G8ZkneTEwm9MO9JgCIMeta } from "/tmp/build_5fd1643e/pages/app/community.vue?macro=true";
import { default as indexuUsWW8S0LqXe3_7xAeSfikMDw79q3Qg6o22TZ33MagQMeta } from "/tmp/build_5fd1643e/pages/app/quiz/[id]/index.vue?macro=true";
import { default as _91id_93a1nBYDSFmXl836kRWJsyivhD08wihcCZB8GbvAhGI_MMeta } from "/tmp/build_5fd1643e/pages/app/quiz/[id].vue?macro=true";
import { default as indexxXSHnrolX1w8R_Y0bKk9x7pZ_oCdfPmlratwcYrbtO0Meta } from "/tmp/build_5fd1643e/pages/app/auth/index.vue?macro=true";
import { default as aboutjsg8oJwilSE3rcHN1czOzahs7E_45D8eU8ZyVKLYr71NAMeta } from "/tmp/build_5fd1643e/pages/app/onboarding/about.vue?macro=true";
import { default as emailybgeWtQMn60hNfPKQKaqGlM228x8_yklc8boeEm_45N3UMeta } from "/tmp/build_5fd1643e/pages/app/onboarding/email.vue?macro=true";
import { default as goalsaf0Q3IsAJ8agzVQKjAniAIMtOeet6FT4mL6_e4l73g8Meta } from "/tmp/build_5fd1643e/pages/app/onboarding/goals.vue?macro=true";
import { default as indexeWkLsdJZQGwlZ8aEYc4bs1ngUVJYMpzQoxs61nHhFKMMeta } from "/tmp/build_5fd1643e/pages/app/onboarding/index.vue?macro=true";
import { default as phonekKg9EksTl_7_2YfZDFA_45oKH7vbSPNEzbWKQw8vuOjiMMeta } from "/tmp/build_5fd1643e/pages/app/onboarding/phone.vue?macro=true";
import { default as groupsucXZebUqL5Uru92qcUPWZSYK8l499x4QxGneM17csPEMeta } from "/tmp/build_5fd1643e/pages/app/onboarding/groups.vue?macro=true";
import { default as searchOv8ld9IYUHMGLaXhiGk8Kbp2hr9JL7ekdbkj17OC1Q8Meta } from "/tmp/build_5fd1643e/pages/app/onboarding/search.vue?macro=true";
import { default as charter5_tW3Z7qqHQGs2YmrK7wuvmVhGrbkV9zx5BHYP9SxiMMeta } from "/tmp/build_5fd1643e/pages/app/onboarding/charter.vue?macro=true";
import { default as loadingdrOliPS8R6Q1VvX7FHAkrHlHb42MrvM9B_Y_uV6ZWXUMeta } from "/tmp/build_5fd1643e/pages/app/onboarding/loading.vue?macro=true";
import { default as profilexNJshm0J_45GgE_1qQztkdSXjCEvtmB77WJ6KMB3eNhmAMeta } from "/tmp/build_5fd1643e/pages/app/onboarding/profile.vue?macro=true";
import { default as identityqRASRAZsACVQ_45JxmNGppQ2b3WBZN_UNVYHDTgb9dSGEMeta } from "/tmp/build_5fd1643e/pages/app/onboarding/identity.vue?macro=true";
import { default as profileseeNfPuR3DqnrJSDQiqBVvKlXBM57TRlNjDW6YwuofgYMeta } from "/tmp/build_5fd1643e/pages/app/onboarding/profiles.vue?macro=true";
import { default as membershipIPDJk9j7zS2XlR5JOcW8lrbGMe4y_45mwsoLYDwjmsOUgMeta } from "/tmp/build_5fd1643e/pages/app/onboarding/membership.vue?macro=true";
import { default as permissionsh87XYhAgZ8Ia2ATcqXqsafTEwEbX7SVN_I_45yT4b5ntsMeta } from "/tmp/build_5fd1643e/pages/app/onboarding/permissions.vue?macro=true";
import { default as onboardinghz8NsoUGURqQyKC5_45jfSOMlXzznrJ3cH8Ng1p6T0PdkMeta } from "/tmp/build_5fd1643e/pages/app/onboarding.vue?macro=true";
import { default as indexMAT1nANBUSUms6_45q_gieFoLHDPylQCTP35VUTAFxBUoMeta } from "/tmp/build_5fd1643e/pages/app/quiz/index.vue?macro=true";
import { default as investorsluensKdgokblUFueIF8juRrO_szY7TazHuP6W4HifHAMeta } from "/tmp/build_5fd1643e/pages/main/investors.vue?macro=true";
import { default as _91id_93ErrIRtlZO3YnBStvHWMJzTNSjVuV3MuF9g8CtykI0_oMeta } from "/tmp/build_5fd1643e/pages/admin/blog/[id].vue?macro=true";
import { default as broadcastnHMLD3CuIdwF3TrVX018GB_459rhaTkWQ_45oZndmGr4iecMeta } from "/tmp/build_5fd1643e/pages/admin/broadcast.vue?macro=true";
import { default as deletez_tqAZi3w3tOOgCKdpkQ_45Coy6dvCsr2FAUddmR3BlT8Meta } from "/tmp/build_5fd1643e/pages/app/auth/delete.vue?macro=true";
import { default as logout2DDvHpL0sNlv_XmPLJZJy9DqBCNg4x09uHti7fzrVAAMeta } from "/tmp/build_5fd1643e/pages/app/auth/logout.vue?macro=true";
import { default as indexqSs5uhL7_45XD0XkyIZJEd4OryqKaASOr4i7YyXnDdDIkMeta } from "/tmp/build_5fd1643e/pages/app/story/index.vue?macro=true";
import { default as indexb7d0JFTk4Sdmuc9mQ9Tirh2b1v4cdlGeYyANUEUmrZwMeta } from "/tmp/build_5fd1643e/pages/backstage/index.vue?macro=true";
import { default as indexWPJiGFFn_UrBsRu8tG0b4X3j3DrKlsU3t3Af8SsJxE4Meta } from "/tmp/build_5fd1643e/pages/main/auth/index.vue?macro=true";
import { default as index89TmP96eRPRzU0PyabeEm2vfVydMaLp63CPfNqAavaIMeta } from "/tmp/build_5fd1643e/pages/main/blog/index.vue?macro=true";
import { default as indexejc9uWZGvqOozmmfTES_eYjwrzFDjSvBhVBZ7IJDpVYMeta } from "/tmp/build_5fd1643e/pages/admin/auth/index.vue?macro=true";
import { default as indexjGooy9UMNpV0l_Chc42jzT_69bv55WPN1GL3QIanvN8Meta } from "/tmp/build_5fd1643e/pages/admin/blog/index.vue?macro=true";
import { default as deleteFyCPCEK7VnmHCDpyn7DbIH_45__fbJYDt6HO290_45wcpDMMeta } from "/tmp/build_5fd1643e/pages/main/auth/delete.vue?macro=true";
import { default as _91slug_93EzUy3XqDMD0LUL00VY58h6optdqnbfqpGrw2pVczf6UMeta } from "/tmp/build_5fd1643e/pages/main/blog/[slug].vue?macro=true";
import { default as indextI5Fs_45B9XPOGzso56d9TVpNrLcd7HajXkXn4agwhIB0Meta } from "/tmp/build_5fd1643e/pages/main/event/index.vue?macro=true";
import { default as _91token_93QbjO_45DptJbZw4_lJSA8aegyQyYeY9b66pQBPaDG3CXcMeta } from "/tmp/build_5fd1643e/pages/payments/[token].vue?macro=true";
import { default as editWcQw2C_vi7tHg93c7dmXr7hbg8QJ_45qYBzmlH_45CdjXccMeta } from "/tmp/build_5fd1643e/pages/app/events/[slug]/edit.vue?macro=true";
import { default as indexqSa3zxURzdyBGMvXBDNejKmKF8zA0EKRMnktqqPCLLQMeta } from "/tmp/build_5fd1643e/pages/app/events/[slug]/index.vue?macro=true";
import { default as _91slug_93JE3x2Qqh3_3ccKJZoFLq0_XcnBdRus2bSPDykoTsWoQMeta } from "/tmp/build_5fd1643e/pages/app/events/[slug].vue?macro=true";
import { default as createWdrRekoX2csyBeiOK_mHZigFoY8NejYYONyJwL2YXW8Meta } from "/tmp/build_5fd1643e/pages/app/events/create.vue?macro=true";
import { default as list16N0tGm6QBprwQUOJ1xw8ENwBi_gNH2IixKTifSbeJUMeta } from "/tmp/build_5fd1643e/pages/app/partners/list.vue?macro=true";
import { default as _91slug_93utNBbGgpwSiCaMB7Ovy_45p7fYz6cnfkbwaIQiEgy5GFcMeta } from "/tmp/build_5fd1643e/pages/main/event/[slug].vue?macro=true";
import { default as _91slug_93f__u1w1zuZTDnURe_vI9UcOz2WKkIO4vraxNyzlkvCsMeta } from "/tmp/build_5fd1643e/pages/main/group/[slug].vue?macro=true";
import { default as _91slug_93c3DbRQ52p3cwCBIejAYlTIoI1spc8j1Npubk_BdPvHIMeta } from "/tmp/build_5fd1643e/pages/main/place/[slug].vue?macro=true";
import { default as _91city_93CFA_456wLCnxiD8tpvEsfa_45vdxAjUpaApYjcWtBSeNvdAMeta } from "/tmp/build_5fd1643e/pages/main/cities/[city].vue?macro=true";
import { default as _91slug_93IrXnRAUbdsOVRB1qpxYH8BOQAYOHbQxjxKZUSumdjzsMeta } from "/tmp/build_5fd1643e/pages/main/invite/[slug].vue?macro=true";
import { default as organizationsS9KZNM2ZeH8mHu2wAPnwtCmnrUYGl15c0pUB4bkToBoMeta } from "/tmp/build_5fd1643e/pages/admin/organizations.vue?macro=true";
import { default as indexiS9fkgJkwJraApPTpxOo9PJhpFFQB_450ZKZ0aCBmC7GwMeta } from "/tmp/build_5fd1643e/pages/admin/reports/index.vue?macro=true";
import { default as eventsiANHFzNvBrkOp82xApktAOLevk_yIrZoPxS_HQiABHYMeta } from "/tmp/build_5fd1643e/pages/admin/reports/events.vue?macro=true";
import { default as preferences3oWzn20JW0v7z2sBXGLIi_W40_EF3HYHNsGd2A_45FYTwMeta } from "/tmp/build_5fd1643e/pages/app/auth/preferences.vue?macro=true";
import { default as loginNYmWNzzY3wnAGj5ml5u8_YvEwqHDEm6W0QI1FahZbsQMeta } from "/tmp/build_5fd1643e/pages/backstage/auth/login.vue?macro=true";
import { default as _91id_93Eyq37wboAMgvXOk3PKAS2uxZQ5tii3JRp35vYegANxAMeta } from "/tmp/build_5fd1643e/pages/app/conversation/[id].vue?macro=true";
import { default as logoutayuBMhaSqFGCO5AEZ0NuBHletVjYgMP_45S3Ftq7wa4ZcMeta } from "/tmp/build_5fd1643e/pages/backstage/auth/logout.vue?macro=true";
import { default as preferencest8QZo2YjYQXMZ1l5J_LpeyEm0ElA3T2Znk1oV0fvWMEMeta } from "/tmp/build_5fd1643e/pages/main/auth/preferences.vue?macro=true";
import { default as listE9knUiDkwK7v77WffOaaAlTTJ8hnqNMcVdfM2Q_DqpEMeta } from "/tmp/build_5fd1643e/pages/app/organizations/list.vue?macro=true";
import { default as _91token_93wFqMlP0pM05x8N8Hsk1y3n70Gc5owmO5ksEyizQaPpIMeta } from "/tmp/build_5fd1643e/pages/app/auth/verify/[token].vue?macro=true";
import { default as registerGyKuhqwhbpGA3Vo2ACCfh0DxJBbXyxEjkHsCdUEaQI8Meta } from "/tmp/build_5fd1643e/pages/backstage/auth/register.vue?macro=true";
import { default as _91code_93Q6TEdYRtHwY2ixLsytwcErfaJgmSLEaawiWgn2iLokAMeta } from "/tmp/build_5fd1643e/pages/backstage/invite/[code].vue?macro=true";
import { default as discordo18NSBjhLL9ZwKbjS_45yBdF_45a55uKbGdVXdmRY8mFvIQMeta } from "/tmp/build_5fd1643e/pages/app/integrations/discord.vue?macro=true";
import { default as indexNSgcpV048vsvejjFirXbeTexKrfcTPcZdDSYXxrNq6kMeta } from "/tmp/build_5fd1643e/pages/backstage/dashboard/index.vue?macro=true";
import { default as questions_45frequentes5ArZeNB5mvNsFxd5hznbOn_45vGGWr71vlxkheGIY18DsMeta } from "/tmp/build_5fd1643e/pages/main/questions-frequentes.vue?macro=true";
import { default as discord_45authHFTKk8l1nRcWNQ0H9xQwqYUkG21MNREVuJjnlVmldPAMeta } from "/tmp/build_5fd1643e/pages/app/integrations/discord-auth.vue?macro=true";
import { default as subscribehtw7jvyrmXom9kl_45hjtN1M50LZdBZ2eO2ec_whghV_8Meta } from "/tmp/build_5fd1643e/pages/backstage/dashboard/subscribe.vue?macro=true";
import { default as indexF1ti7KZa_45Zc3F_45X2CuzLdtXEhULz55SYfPYbcMWgRxoMeta } from "/tmp/build_5fd1643e/pages/backstage/dashboard/events/index.vue?macro=true";
import { default as indexXu7J_1Jfk6oTATivm6ZJPHGNOcCV13poF_NYzvAfxRUMeta } from "/tmp/build_5fd1643e/pages/backstage/dashboard/places/index.vue?macro=true";
import { default as indexdAeCpwdaDi0maVZ_45vUqS296cczORYIV_452W8PHz5L69cMeta } from "/tmp/build_5fd1643e/pages/backstage/dashboard/events/[slug]/edit/index.vue?macro=true";
import { default as detailsoZCxxEeGePB7eknSFVjBYqqkWWoYBau2Ebf1uRlhwjwMeta } from "/tmp/build_5fd1643e/pages/backstage/dashboard/events/[slug]/edit/details.vue?macro=true";
import { default as advancedqifeeKvgj8q54vEVK0dwT4B_45Pm7L6sjFjCtnTW9cX_454Meta } from "/tmp/build_5fd1643e/pages/backstage/dashboard/events/[slug]/edit/advanced.vue?macro=true";
import { default as attendeesMoRIPmloLQVBPR052nATTvKmCduN8uggLu_456jkynoH0Meta } from "/tmp/build_5fd1643e/pages/backstage/dashboard/events/[slug]/edit/attendees.vue?macro=true";
import { default as edit9M8jBbiEZ3yVmMIxDsHFCD87HDAp1jzaWd1TsaGA5f4Meta } from "/tmp/build_5fd1643e/pages/backstage/dashboard/events/[slug]/edit.vue?macro=true";
import { default as indexJsE9GVMdOCLYj6LrvpHuIXtU3hE_NQWZSQmn7RXx1GkMeta } from "/tmp/build_5fd1643e/pages/backstage/dashboard/events/[slug]/index.vue?macro=true";
import { default as attendeesKMyDQeHfGoYfT0_tZhSHrQGYx_45a9s8_45I_0HdGJXZFxYMeta } from "/tmp/build_5fd1643e/pages/backstage/dashboard/events/[slug]/attendees.vue?macro=true";
import { default as _91slug_93ZKDftc8KibnxOKBhJsCXCbpKo5xh_45781VXkIieqXkO8Meta } from "/tmp/build_5fd1643e/pages/backstage/dashboard/events/[slug].vue?macro=true";
import { default as createVdwIgpBw4KtwPhJ3ymcm9OGyJpLYMFFs4qkLVqzKEsIMeta } from "/tmp/build_5fd1643e/pages/backstage/dashboard/events/create.vue?macro=true";
import { default as index0ooxqmCaz1F_45iZ7rouS53GV10FGDUaRwk0esyXIJ38cMeta } from "/tmp/build_5fd1643e/pages/backstage/dashboard/settings/index.vue?macro=true";
import { default as index6FEQWgB1EzROUBQQ6_45L3ZY1N1LA_hRN6lTs4SPFHSZQMeta } from "/tmp/build_5fd1643e/pages/backstage/dashboard/organization/index.vue?macro=true";
import { default as component_45stub8I9CL0_45s4ZQHr2GlR1J4zEiqF5lOCZRmbkWGPFk9ZGoMeta } from "/tmp/build_5fd1643e/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stub8I9CL0_45s4ZQHr2GlR1J4zEiqF5lOCZRmbkWGPFk9ZGo } from "/tmp/build_5fd1643e/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: meoflm_4t0LxX_45av5VTCwblyuhVHZEkrSqWRo9FCneCuAMeta?.name,
    path: "/app/me",
    meta: meoflm_4t0LxX_45av5VTCwblyuhVHZEkrSqWRo9FCneCuAMeta || {},
    component: () => import("/tmp/build_5fd1643e/pages/app/me.vue"),
    children: [
  {
    name: "app-me",
    path: "",
    component: () => import("/tmp/build_5fd1643e/pages/app/me/index.vue")
  }
]
  },
  {
    name: "app-map",
    path: "/app/map",
    meta: { ...(mapGr6LghDr4R1P1KQ6opt1czsKiyCouyNTR1e1toWLL5MMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_5fd1643e/pages/app/map.vue")
  },
  {
    name: feedgBl5bjZnJZGsU2hPHrB7ddiCRgVW45j_1eNO4DCbicsMeta?.name,
    path: "/app/feed",
    meta: { ...(feedgBl5bjZnJZGsU2hPHrB7ddiCRgVW45j_1eNO4DCbicsMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_5fd1643e/pages/app/feed.vue"),
    children: [
  {
    name: "app-feed-post",
    path: "post",
    meta: posttr4k1NyoxQ3RjVjn94gGleI0sTCYVzRGchcKLgSPpcoMeta || {},
    component: () => import("/tmp/build_5fd1643e/pages/app/feed/post.vue")
  },
  {
    name: "app-feed",
    path: "",
    meta: indexDsMcTvdZr3K9ycjstvoZX3MPh5vqUAZey1_45l9KpbOxgMeta || {},
    component: () => import("/tmp/build_5fd1643e/pages/app/feed/index.vue")
  },
  {
    name: "app-feed-type",
    path: ":type()",
    meta: _91type_93LQJna88Zh9iI0ALbYGdnEdgRGTt4Bw18osokL9GUk4oMeta || {},
    component: () => import("/tmp/build_5fd1643e/pages/app/feed/[type].vue")
  }
]
  },
  {
    name: "app",
    path: "/app",
    meta: { ...(indexwVSctWQ39IVNvfFY2l7Tg19V3iSl0kW521jF698E18EMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_5fd1643e/pages/app/index.vue")
  },
  {
    name: "main-eula",
    path: "/main/eula",
    meta: eulaTAoHC4jcBxVdMhqP7VmGACgteF_4YNX5CUS6el8to3cMeta || {},
    component: () => import("/tmp/build_5fd1643e/pages/main/eula.vue")
  },
  {
    name: "admin-quiz",
    path: "/admin/quiz",
    meta: { ...(quizIfaMX7z17QahxOUitwjUpDv3E_45jUkrdpkW4TKniYLPkMeta || {}), ...{"middleware":["is-admin"]} },
    component: () => import("/tmp/build_5fd1643e/pages/admin/quiz.vue")
  },
  {
    name: groups4L_45g269ne9vnCv81OqJBv5Qxc4qqWSOdnQ87cRsgVPsMeta?.name,
    path: "/app/groups",
    meta: { ...(groups4L_45g269ne9vnCv81OqJBv5Qxc4qqWSOdnQ87cRsgVPsMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_5fd1643e/pages/app/groups.vue"),
    children: [
  {
    name: "app-groups",
    path: "",
    component: () => import("/tmp/build_5fd1643e/pages/app/groups/index.vue")
  },
  {
    name: _91slug_93_zzTANY_45tYnryox4kiX9MvbA3OWYzZgNt_45amkW_u8_45gMeta?.name,
    path: ":slug()",
    meta: _91slug_93_zzTANY_45tYnryox4kiX9MvbA3OWYzZgNt_45amkW_u8_45gMeta || {},
    component: () => import("/tmp/build_5fd1643e/pages/app/groups/[slug].vue"),
    children: [
  {
    name: "app-groups-slug-edit",
    path: "edit",
    component: () => import("/tmp/build_5fd1643e/pages/app/groups/[slug]/edit.vue")
  },
  {
    name: "app-groups-slug-about",
    path: "about",
    component: () => import("/tmp/build_5fd1643e/pages/app/groups/[slug]/about.vue")
  },
  {
    name: "app-groups-slug",
    path: "",
    component: () => import("/tmp/build_5fd1643e/pages/app/groups/[slug]/index.vue")
  },
  {
    name: "app-groups-slug-events",
    path: "events",
    component: () => import("/tmp/build_5fd1643e/pages/app/groups/[slug]/events.vue")
  },
  {
    name: "app-groups-slug-members",
    path: "members",
    component: () => import("/tmp/build_5fd1643e/pages/app/groups/[slug]/members.vue")
  },
  {
    name: "app-groups-slug-conversations",
    path: "conversations",
    component: () => import("/tmp/build_5fd1643e/pages/app/groups/[slug]/conversations.vue")
  }
]
  },
  {
    name: "app-groups-create",
    path: "create",
    meta: createnO3Lm0K_45BTt0DecNKunBuigToAxr0yousOfXjcQe2_45sMeta || {},
    component: () => import("/tmp/build_5fd1643e/pages/app/groups/create.vue")
  }
]
  },
  {
    name: paramsxPCQ1YgO2g8lTKupqjIfsBiFig5Rry7iCBFlL2dPBUoMeta?.name,
    path: "/app/params",
    meta: { ...(paramsxPCQ1YgO2g8lTKupqjIfsBiFig5Rry7iCBFlL2dPBUoMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_5fd1643e/pages/app/params.vue"),
    children: [
  {
    name: "app-params",
    path: "",
    meta: { ...(indexJL_kQ4bD1ksWN6nF72Ovt8IZbyBvVmwuMzNYuGt8iSEMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_5fd1643e/pages/app/params/index.vue")
  },
  {
    name: "app-params-account",
    path: "account",
    meta: { ...(account_h9AtNMdDZ1g3Z5RbetsT_IFR8SRBraBPXPA87Jv56kMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_5fd1643e/pages/app/params/account.vue")
  },
  {
    name: "app-params-transactions",
    path: "transactions",
    meta: { ...(transactionsa9HSSn4A2V_45eohgqnwWOxhFE_45MKeuVkXZI2_KKbAWkAMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_5fd1643e/pages/app/params/transactions.vue")
  }
]
  },
  {
    name: "main",
    path: "/main",
    meta: indexoRUFpAn5JZSWAenZngDJ_45Y601fgwpT6KWmLO9SGkPaoMeta || {},
    component: () => import("/tmp/build_5fd1643e/pages/main/index.vue")
  },
  {
    name: "main-press",
    path: "/main/press",
    meta: pressH9frTRaSwyhOBTwNUMjvg1FJMzbB2AvLcYhKZ9iTGVoMeta || {},
    component: () => import("/tmp/build_5fd1643e/pages/main/press.vue")
  },
  {
    name: "admin-codes",
    path: "/admin/codes",
    meta: { ...(codesbqnSuMlq2j_45mhGaTz3y1oT8m2wmQVA1giMog9a1BnRcMeta || {}), ...{"middleware":["is-admin"]} },
    component: () => import("/tmp/build_5fd1643e/pages/admin/codes.vue")
  },
  {
    name: "admin",
    path: "/admin",
    meta: { ...(indexZDj11aILdWswQApPGQd93olffd8BmAQW8TTukHW_45JuAMeta || {}), ...{"middleware":["is-admin"]} },
    component: () => import("/tmp/build_5fd1643e/pages/admin/index.vue")
  },
  {
    name: hangoutzFsiKRV7NjazThcJREdyWhwSJtlwSrRYbs0lXnRws4IMeta?.name,
    path: "/app/hangout",
    meta: { ...(hangoutzFsiKRV7NjazThcJREdyWhwSJtlwSrRYbs0lXnRws4IMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_5fd1643e/pages/app/hangout.vue"),
    children: [
  {
    name: "app-hangout",
    path: "",
    meta: indexlwCzVppMqBJ1cr1njjPWU2yCsXxmJ4FeXIrda4dqHEkMeta || {},
    component: () => import("/tmp/build_5fd1643e/pages/app/hangout/index.vue")
  },
  {
    name: "app-hangout-agenda",
    path: "agenda",
    meta: { ...(agendaT5qOENNgs4JvinoQhxlyK8JhnZ8AK4YAgaSHyPd1ZtAMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_5fd1643e/pages/app/hangout/agenda.vue")
  },
  {
    name: "app-hangout-meetups",
    path: "meetups",
    meta: meetupsrBHpl4_45kfPSr_DnX4c_f_45FrXonO8eEVxqVq7x4T7jXAMeta || {},
    component: () => import("/tmp/build_5fd1643e/pages/app/hangout/meetups.vue")
  },
  {
    name: "app-hangout-organize",
    path: "organize",
    meta: { ...(organizeK8fI8ofB9mE3SJcvDs0USWDZ8Lp8k3pbMWgR0X3CD_45gMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_5fd1643e/pages/app/hangout/organize.vue")
  }
]
  },
  {
    name: "main-charte",
    path: "/main/charte",
    meta: charte6Owfx4_If6rpFlD9ZQ1gVEq3XCuXxWE5tRWBNHA_aEsMeta || {},
    component: () => import("/tmp/build_5fd1643e/pages/main/charte.vue")
  },
  {
    name: "main-france",
    path: "/main/france",
    meta: franceoQj9DkNkX3GR44nwBWVvq7MAemxlGKlpmQl0MKmY_BYMeta || {},
    component: () => import("/tmp/build_5fd1643e/pages/main/france.vue")
  },
  {
    name: "admin-themes",
    path: "/admin/themes",
    meta: { ...(themesHCoAkE0ZjmbzuqKupJ09ZVNLyOPqkNIdGI_4522P0FgtsMeta || {}), ...{"middleware":["is-admin"]} },
    component: () => import("/tmp/build_5fd1643e/pages/admin/themes.vue")
  },
  {
    name: insidersduxQPWhGnGclT3wTdTwerMPjq0Fa9HbGVl3lzcditToMeta?.name,
    path: "/app/insiders",
    meta: { ...(insidersduxQPWhGnGclT3wTdTwerMPjq0Fa9HbGVl3lzcditToMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_5fd1643e/pages/app/insiders.vue"),
    children: [
  {
    name: "app-insiders",
    path: "",
    component: () => import("/tmp/build_5fd1643e/pages/app/insiders/index.vue")
  },
  {
    name: "app-insiders-suggestions",
    path: "suggestions",
    meta: suggestionsW5vaBJrFDCdP5P0SacIVi0TU9UsMoye5Q3YhimjMvmEMeta || {},
    component: () => import("/tmp/build_5fd1643e/pages/app/insiders/suggestions.vue")
  }
]
  },
  {
    name: "app-messages",
    path: "/app/messages",
    meta: { ...(messages1NbqKLXgNZUPrBV223dsJVRC20wIJ40s6QhpJB0pIZsMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_5fd1643e/pages/app/messages.vue")
  },
  {
    name: "main-privacy",
    path: "/main/privacy",
    meta: privacyZenwQmkImbyKGHm2rX3VG2XVT3wibWyDNxhVNSOe88MMeta || {},
    component: () => import("/tmp/build_5fd1643e/pages/main/privacy.vue")
  },
  {
    name: "admin-trainer",
    path: "/admin/trainer",
    meta: { ...(trainerFESIsgxBFL70jxYAa4iSZ0vNQI6TrFTp_Ph6UF4Zl0UMeta || {}), ...{"middleware":["is-admin"]} },
    component: () => import("/tmp/build_5fd1643e/pages/admin/trainer.vue")
  },
  {
    name: communityXNPjwMS_5RD1B9KCoYi3Rl869G8ZkneTEwm9MO9JgCIMeta?.name,
    path: "/app/community",
    meta: { ...(communityXNPjwMS_5RD1B9KCoYi3Rl869G8ZkneTEwm9MO9JgCIMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_5fd1643e/pages/app/community.vue"),
    children: [
  {
    name: "app-community",
    path: "",
    meta: indexS7UGE8dbY49uWXuYacZAUD_6Iozd_45RmDNzWaFPVNpPYMeta || {},
    component: () => import("/tmp/build_5fd1643e/pages/app/community/index.vue")
  },
  {
    name: "app-community-search",
    path: "search",
    meta: searchUnCrxsN8kqJiuQCtHALAqQZdKfqdjXNAVqYdb5EKt5IMeta || {},
    component: () => import("/tmp/build_5fd1643e/pages/app/community/search.vue")
  },
  {
    name: "app-community-besties",
    path: "besties",
    component: () => import("/tmp/build_5fd1643e/pages/app/community/besties.vue")
  },
  {
    name: "app-community-type",
    path: ":type()",
    meta: { ...(indexpXe9QK4kzHWeaonFGAiaARJZLa8UF_BDMT8DqBtDyHEMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_5fd1643e/pages/app/community/[type]/index.vue")
  }
]
  },
  {
    name: _91id_93a1nBYDSFmXl836kRWJsyivhD08wihcCZB8GbvAhGI_MMeta?.name,
    path: "/app/quiz/:id()",
    meta: { ...(_91id_93a1nBYDSFmXl836kRWJsyivhD08wihcCZB8GbvAhGI_MMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_5fd1643e/pages/app/quiz/[id].vue"),
    children: [
  {
    name: "app-quiz-id",
    path: "",
    component: () => import("/tmp/build_5fd1643e/pages/app/quiz/[id]/index.vue")
  }
]
  },
  {
    name: "app-auth",
    path: "/app/auth",
    meta: { ...(indexxXSHnrolX1w8R_Y0bKk9x7pZ_oCdfPmlratwcYrbtO0Meta || {}), ...{"middleware":["is-not-user"]} },
    component: () => import("/tmp/build_5fd1643e/pages/app/auth/index.vue")
  },
  {
    name: onboardinghz8NsoUGURqQyKC5_45jfSOMlXzznrJ3cH8Ng1p6T0PdkMeta?.name,
    path: "/app/onboarding",
    meta: { ...(onboardinghz8NsoUGURqQyKC5_45jfSOMlXzznrJ3cH8Ng1p6T0PdkMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_5fd1643e/pages/app/onboarding.vue"),
    children: [
  {
    name: "app-onboarding-about",
    path: "about",
    component: () => import("/tmp/build_5fd1643e/pages/app/onboarding/about.vue")
  },
  {
    name: "app-onboarding-email",
    path: "email",
    component: () => import("/tmp/build_5fd1643e/pages/app/onboarding/email.vue")
  },
  {
    name: "app-onboarding-goals",
    path: "goals",
    component: () => import("/tmp/build_5fd1643e/pages/app/onboarding/goals.vue")
  },
  {
    name: "app-onboarding",
    path: "",
    meta: indexeWkLsdJZQGwlZ8aEYc4bs1ngUVJYMpzQoxs61nHhFKMMeta || {},
    component: () => import("/tmp/build_5fd1643e/pages/app/onboarding/index.vue")
  },
  {
    name: "app-onboarding-phone",
    path: "phone",
    component: () => import("/tmp/build_5fd1643e/pages/app/onboarding/phone.vue")
  },
  {
    name: "app-onboarding-groups",
    path: "groups",
    component: () => import("/tmp/build_5fd1643e/pages/app/onboarding/groups.vue")
  },
  {
    name: "app-onboarding-search",
    path: "search",
    component: () => import("/tmp/build_5fd1643e/pages/app/onboarding/search.vue")
  },
  {
    name: "app-onboarding-charter",
    path: "charter",
    component: () => import("/tmp/build_5fd1643e/pages/app/onboarding/charter.vue")
  },
  {
    name: "app-onboarding-loading",
    path: "loading",
    component: () => import("/tmp/build_5fd1643e/pages/app/onboarding/loading.vue")
  },
  {
    name: "app-onboarding-profile",
    path: "profile",
    component: () => import("/tmp/build_5fd1643e/pages/app/onboarding/profile.vue")
  },
  {
    name: "app-onboarding-identity",
    path: "identity",
    component: () => import("/tmp/build_5fd1643e/pages/app/onboarding/identity.vue")
  },
  {
    name: "app-onboarding-profiles",
    path: "profiles",
    component: () => import("/tmp/build_5fd1643e/pages/app/onboarding/profiles.vue")
  },
  {
    name: "app-onboarding-membership",
    path: "membership",
    component: () => import("/tmp/build_5fd1643e/pages/app/onboarding/membership.vue")
  },
  {
    name: "app-onboarding-permissions",
    path: "permissions",
    component: () => import("/tmp/build_5fd1643e/pages/app/onboarding/permissions.vue")
  }
]
  },
  {
    name: "app-quiz",
    path: "/app/quiz",
    meta: { ...(indexMAT1nANBUSUms6_45q_gieFoLHDPylQCTP35VUTAFxBUoMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_5fd1643e/pages/app/quiz/index.vue")
  },
  {
    name: "main-investors",
    path: "/main/investors",
    meta: investorsluensKdgokblUFueIF8juRrO_szY7TazHuP6W4HifHAMeta || {},
    component: () => import("/tmp/build_5fd1643e/pages/main/investors.vue")
  },
  {
    name: "admin-blog-id",
    path: "/admin/blog/:id()",
    meta: { ...(_91id_93ErrIRtlZO3YnBStvHWMJzTNSjVuV3MuF9g8CtykI0_oMeta || {}), ...{"middleware":["is-admin"]} },
    component: () => import("/tmp/build_5fd1643e/pages/admin/blog/[id].vue")
  },
  {
    name: "admin-broadcast",
    path: "/admin/broadcast",
    meta: { ...(broadcastnHMLD3CuIdwF3TrVX018GB_459rhaTkWQ_45oZndmGr4iecMeta || {}), ...{"middleware":["is-admin"]} },
    component: () => import("/tmp/build_5fd1643e/pages/admin/broadcast.vue")
  },
  {
    name: "app-auth-delete",
    path: "/app/auth/delete",
    meta: deletez_tqAZi3w3tOOgCKdpkQ_45Coy6dvCsr2FAUddmR3BlT8Meta || {},
    component: () => import("/tmp/build_5fd1643e/pages/app/auth/delete.vue")
  },
  {
    name: "app-auth-logout",
    path: "/app/auth/logout",
    meta: logout2DDvHpL0sNlv_XmPLJZJy9DqBCNg4x09uHti7fzrVAAMeta || {},
    component: () => import("/tmp/build_5fd1643e/pages/app/auth/logout.vue")
  },
  {
    name: "app-story",
    path: "/app/story",
    meta: { ...(indexqSs5uhL7_45XD0XkyIZJEd4OryqKaASOr4i7YyXnDdDIkMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_5fd1643e/pages/app/story/index.vue")
  },
  {
    name: "backstage",
    path: "/backstage",
    meta: { ...(indexb7d0JFTk4Sdmuc9mQ9Tirh2b1v4cdlGeYyANUEUmrZwMeta || {}), ...{"middleware":["backstage-auth"]} },
    component: () => import("/tmp/build_5fd1643e/pages/backstage/index.vue")
  },
  {
    name: "main-auth",
    path: "/main/auth",
    component: () => import("/tmp/build_5fd1643e/pages/main/auth/index.vue")
  },
  {
    name: "main-blog",
    path: "/main/blog",
    meta: index89TmP96eRPRzU0PyabeEm2vfVydMaLp63CPfNqAavaIMeta || {},
    component: () => import("/tmp/build_5fd1643e/pages/main/blog/index.vue")
  },
  {
    name: "admin-auth",
    path: "/admin/auth",
    meta: indexejc9uWZGvqOozmmfTES_eYjwrzFDjSvBhVBZ7IJDpVYMeta || {},
    component: () => import("/tmp/build_5fd1643e/pages/admin/auth/index.vue")
  },
  {
    name: "admin-blog",
    path: "/admin/blog",
    meta: { ...(indexjGooy9UMNpV0l_Chc42jzT_69bv55WPN1GL3QIanvN8Meta || {}), ...{"middleware":["is-admin"]} },
    component: () => import("/tmp/build_5fd1643e/pages/admin/blog/index.vue")
  },
  {
    name: "main-auth-delete",
    path: "/main/auth/delete",
    component: () => import("/tmp/build_5fd1643e/pages/main/auth/delete.vue")
  },
  {
    name: "main-blog-slug",
    path: "/main/blog/:slug()",
    meta: _91slug_93EzUy3XqDMD0LUL00VY58h6optdqnbfqpGrw2pVczf6UMeta || {},
    component: () => import("/tmp/build_5fd1643e/pages/main/blog/[slug].vue")
  },
  {
    name: "main-event",
    path: "/main/event",
    meta: indextI5Fs_45B9XPOGzso56d9TVpNrLcd7HajXkXn4agwhIB0Meta || {},
    component: () => import("/tmp/build_5fd1643e/pages/main/event/index.vue")
  },
  {
    name: "payments-token",
    path: "/payments/:token()",
    meta: _91token_93QbjO_45DptJbZw4_lJSA8aegyQyYeY9b66pQBPaDG3CXcMeta || {},
    component: () => import("/tmp/build_5fd1643e/pages/payments/[token].vue")
  },
  {
    name: _91slug_93JE3x2Qqh3_3ccKJZoFLq0_XcnBdRus2bSPDykoTsWoQMeta?.name,
    path: "/app/events/:slug()",
    meta: { ...(_91slug_93JE3x2Qqh3_3ccKJZoFLq0_XcnBdRus2bSPDykoTsWoQMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_5fd1643e/pages/app/events/[slug].vue"),
    children: [
  {
    name: "app-events-slug-edit",
    path: "edit",
    meta: editWcQw2C_vi7tHg93c7dmXr7hbg8QJ_45qYBzmlH_45CdjXccMeta || {},
    component: () => import("/tmp/build_5fd1643e/pages/app/events/[slug]/edit.vue")
  },
  {
    name: "app-events-slug",
    path: "",
    component: () => import("/tmp/build_5fd1643e/pages/app/events/[slug]/index.vue")
  }
]
  },
  {
    name: "app-events-create",
    path: "/app/events/create",
    meta: { ...(createWdrRekoX2csyBeiOK_mHZigFoY8NejYYONyJwL2YXW8Meta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_5fd1643e/pages/app/events/create.vue")
  },
  {
    name: "app-partners-list",
    path: "/app/partners/list",
    meta: { ...(list16N0tGm6QBprwQUOJ1xw8ENwBi_gNH2IixKTifSbeJUMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_5fd1643e/pages/app/partners/list.vue")
  },
  {
    name: "main-event-slug",
    path: "/main/event/:slug()",
    meta: _91slug_93utNBbGgpwSiCaMB7Ovy_45p7fYz6cnfkbwaIQiEgy5GFcMeta || {},
    component: () => import("/tmp/build_5fd1643e/pages/main/event/[slug].vue")
  },
  {
    name: "main-group-slug",
    path: "/main/group/:slug()",
    meta: _91slug_93f__u1w1zuZTDnURe_vI9UcOz2WKkIO4vraxNyzlkvCsMeta || {},
    component: () => import("/tmp/build_5fd1643e/pages/main/group/[slug].vue")
  },
  {
    name: "main-place-slug",
    path: "/main/place/:slug()",
    meta: _91slug_93c3DbRQ52p3cwCBIejAYlTIoI1spc8j1Npubk_BdPvHIMeta || {},
    component: () => import("/tmp/build_5fd1643e/pages/main/place/[slug].vue")
  },
  {
    name: "main-cities-city",
    path: "/main/cities/:city()",
    meta: _91city_93CFA_456wLCnxiD8tpvEsfa_45vdxAjUpaApYjcWtBSeNvdAMeta || {},
    component: () => import("/tmp/build_5fd1643e/pages/main/cities/[city].vue")
  },
  {
    name: "main-invite-slug",
    path: "/main/invite/:slug()",
    component: () => import("/tmp/build_5fd1643e/pages/main/invite/[slug].vue")
  },
  {
    name: "admin-organizations",
    path: "/admin/organizations",
    meta: { ...(organizationsS9KZNM2ZeH8mHu2wAPnwtCmnrUYGl15c0pUB4bkToBoMeta || {}), ...{"middleware":["is-admin"]} },
    component: () => import("/tmp/build_5fd1643e/pages/admin/organizations.vue")
  },
  {
    name: "admin-reports",
    path: "/admin/reports",
    meta: { ...(indexiS9fkgJkwJraApPTpxOo9PJhpFFQB_450ZKZ0aCBmC7GwMeta || {}), ...{"middleware":["is-admin"]} },
    component: () => import("/tmp/build_5fd1643e/pages/admin/reports/index.vue")
  },
  {
    name: "admin-reports-events",
    path: "/admin/reports/events",
    meta: { ...(eventsiANHFzNvBrkOp82xApktAOLevk_yIrZoPxS_HQiABHYMeta || {}), ...{"middleware":["is-admin"]} },
    component: () => import("/tmp/build_5fd1643e/pages/admin/reports/events.vue")
  },
  {
    name: "app-auth-preferences",
    path: "/app/auth/preferences",
    meta: preferences3oWzn20JW0v7z2sBXGLIi_W40_EF3HYHNsGd2A_45FYTwMeta || {},
    component: () => import("/tmp/build_5fd1643e/pages/app/auth/preferences.vue")
  },
  {
    name: "backstage-auth-login",
    path: "/backstage/auth/login",
    meta: loginNYmWNzzY3wnAGj5ml5u8_YvEwqHDEm6W0QI1FahZbsQMeta || {},
    component: () => import("/tmp/build_5fd1643e/pages/backstage/auth/login.vue")
  },
  {
    name: "app-conversation-id",
    path: "/app/conversation/:id()",
    meta: { ...(_91id_93Eyq37wboAMgvXOk3PKAS2uxZQ5tii3JRp35vYegANxAMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_5fd1643e/pages/app/conversation/[id].vue")
  },
  {
    name: "backstage-auth-logout",
    path: "/backstage/auth/logout",
    meta: logoutayuBMhaSqFGCO5AEZ0NuBHletVjYgMP_45S3Ftq7wa4ZcMeta || {},
    component: () => import("/tmp/build_5fd1643e/pages/backstage/auth/logout.vue")
  },
  {
    name: "main-auth-preferences",
    path: "/main/auth/preferences",
    component: () => import("/tmp/build_5fd1643e/pages/main/auth/preferences.vue")
  },
  {
    name: "app-organizations-list",
    path: "/app/organizations/list",
    meta: { ...(listE9knUiDkwK7v77WffOaaAlTTJ8hnqNMcVdfM2Q_DqpEMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_5fd1643e/pages/app/organizations/list.vue")
  },
  {
    name: "app-auth-verify-token",
    path: "/app/auth/verify/:token()",
    meta: _91token_93wFqMlP0pM05x8N8Hsk1y3n70Gc5owmO5ksEyizQaPpIMeta || {},
    component: () => import("/tmp/build_5fd1643e/pages/app/auth/verify/[token].vue")
  },
  {
    name: "backstage-auth-register",
    path: "/backstage/auth/register",
    meta: registerGyKuhqwhbpGA3Vo2ACCfh0DxJBbXyxEjkHsCdUEaQI8Meta || {},
    component: () => import("/tmp/build_5fd1643e/pages/backstage/auth/register.vue")
  },
  {
    name: "backstage-invite-code",
    path: "/backstage/invite/:code()",
    meta: _91code_93Q6TEdYRtHwY2ixLsytwcErfaJgmSLEaawiWgn2iLokAMeta || {},
    component: () => import("/tmp/build_5fd1643e/pages/backstage/invite/[code].vue")
  },
  {
    name: "app-integrations-discord",
    path: "/app/integrations/discord",
    meta: discordo18NSBjhLL9ZwKbjS_45yBdF_45a55uKbGdVXdmRY8mFvIQMeta || {},
    component: () => import("/tmp/build_5fd1643e/pages/app/integrations/discord.vue")
  },
  {
    name: "backstage-dashboard",
    path: "/backstage/dashboard",
    meta: { ...(indexNSgcpV048vsvejjFirXbeTexKrfcTPcZdDSYXxrNq6kMeta || {}), ...{"middleware":["backstage-is-user"]} },
    component: () => import("/tmp/build_5fd1643e/pages/backstage/dashboard/index.vue")
  },
  {
    name: "main-questions-frequentes",
    path: "/main/questions-frequentes",
    meta: questions_45frequentes5ArZeNB5mvNsFxd5hznbOn_45vGGWr71vlxkheGIY18DsMeta || {},
    component: () => import("/tmp/build_5fd1643e/pages/main/questions-frequentes.vue")
  },
  {
    name: "app-integrations-discord-auth",
    path: "/app/integrations/discord-auth",
    meta: discord_45authHFTKk8l1nRcWNQ0H9xQwqYUkG21MNREVuJjnlVmldPAMeta || {},
    component: () => import("/tmp/build_5fd1643e/pages/app/integrations/discord-auth.vue")
  },
  {
    name: "backstage-dashboard-subscribe",
    path: "/backstage/dashboard/subscribe",
    meta: { ...(subscribehtw7jvyrmXom9kl_45hjtN1M50LZdBZ2eO2ec_whghV_8Meta || {}), ...{"middleware":["backstage-is-user"]} },
    component: () => import("/tmp/build_5fd1643e/pages/backstage/dashboard/subscribe.vue")
  },
  {
    name: "backstage-dashboard-events",
    path: "/backstage/dashboard/events",
    meta: { ...(indexF1ti7KZa_45Zc3F_45X2CuzLdtXEhULz55SYfPYbcMWgRxoMeta || {}), ...{"middleware":["backstage-is-user"]} },
    component: () => import("/tmp/build_5fd1643e/pages/backstage/dashboard/events/index.vue")
  },
  {
    name: "backstage-dashboard-places",
    path: "/backstage/dashboard/places",
    meta: { ...(indexXu7J_1Jfk6oTATivm6ZJPHGNOcCV13poF_NYzvAfxRUMeta || {}), ...{"middleware":["backstage-is-user"]} },
    component: () => import("/tmp/build_5fd1643e/pages/backstage/dashboard/places/index.vue")
  },
  {
    name: _91slug_93ZKDftc8KibnxOKBhJsCXCbpKo5xh_45781VXkIieqXkO8Meta?.name,
    path: "/backstage/dashboard/events/:slug()",
    component: () => import("/tmp/build_5fd1643e/pages/backstage/dashboard/events/[slug].vue"),
    children: [
  {
    name: edit9M8jBbiEZ3yVmMIxDsHFCD87HDAp1jzaWd1TsaGA5f4Meta?.name,
    path: "edit",
    meta: { ...(edit9M8jBbiEZ3yVmMIxDsHFCD87HDAp1jzaWd1TsaGA5f4Meta || {}), ...{"middleware":["backstage-is-user"]} },
    component: () => import("/tmp/build_5fd1643e/pages/backstage/dashboard/events/[slug]/edit.vue"),
    children: [
  {
    name: "backstage-dashboard-events-slug-edit",
    path: "",
    component: () => import("/tmp/build_5fd1643e/pages/backstage/dashboard/events/[slug]/edit/index.vue")
  },
  {
    name: "backstage-dashboard-events-slug-edit-details",
    path: "details",
    component: () => import("/tmp/build_5fd1643e/pages/backstage/dashboard/events/[slug]/edit/details.vue")
  },
  {
    name: "backstage-dashboard-events-slug-edit-advanced",
    path: "advanced",
    component: () => import("/tmp/build_5fd1643e/pages/backstage/dashboard/events/[slug]/edit/advanced.vue")
  },
  {
    name: "backstage-dashboard-events-slug-edit-attendees",
    path: "attendees",
    component: () => import("/tmp/build_5fd1643e/pages/backstage/dashboard/events/[slug]/edit/attendees.vue")
  }
]
  },
  {
    name: "backstage-dashboard-events-slug",
    path: "",
    meta: { ...(indexJsE9GVMdOCLYj6LrvpHuIXtU3hE_NQWZSQmn7RXx1GkMeta || {}), ...{"middleware":["backstage-is-user"]} },
    component: () => import("/tmp/build_5fd1643e/pages/backstage/dashboard/events/[slug]/index.vue")
  },
  {
    name: "backstage-dashboard-events-slug-attendees",
    path: "attendees",
    meta: { ...(attendeesKMyDQeHfGoYfT0_tZhSHrQGYx_45a9s8_45I_0HdGJXZFxYMeta || {}), ...{"middleware":["backstage-is-user"]} },
    component: () => import("/tmp/build_5fd1643e/pages/backstage/dashboard/events/[slug]/attendees.vue")
  }
]
  },
  {
    name: "backstage-dashboard-events-create",
    path: "/backstage/dashboard/events/create",
    meta: { ...(createVdwIgpBw4KtwPhJ3ymcm9OGyJpLYMFFs4qkLVqzKEsIMeta || {}), ...{"middleware":["backstage-is-user"]} },
    component: () => import("/tmp/build_5fd1643e/pages/backstage/dashboard/events/create.vue")
  },
  {
    name: "backstage-dashboard-settings",
    path: "/backstage/dashboard/settings",
    meta: { ...(index0ooxqmCaz1F_45iZ7rouS53GV10FGDUaRwk0esyXIJ38cMeta || {}), ...{"middleware":["backstage-is-user"]} },
    component: () => import("/tmp/build_5fd1643e/pages/backstage/dashboard/settings/index.vue")
  },
  {
    name: "backstage-dashboard-organization",
    path: "/backstage/dashboard/organization",
    meta: { ...(index6FEQWgB1EzROUBQQ6_45L3ZY1N1LA_hRN6lTs4SPFHSZQMeta || {}), ...{"middleware":["backstage-is-user"]} },
    component: () => import("/tmp/build_5fd1643e/pages/backstage/dashboard/organization/index.vue")
  },
  {
    name: component_45stub8I9CL0_45s4ZQHr2GlR1J4zEiqF5lOCZRmbkWGPFk9ZGoMeta?.name,
    path: "/sitemap.xml",
    component: component_45stub8I9CL0_45s4ZQHr2GlR1J4zEiqF5lOCZRmbkWGPFk9ZGo
  }
]